type UserPermissions = Record<string, string[]>;

interface UsePermissionsProps {
  userPermissions: UserPermissions;
}

export const usePermissions = ({ userPermissions }: UsePermissionsProps) => {
  const hasPermission = (moduleName: string, permission: string | string[]): boolean => {
    const modulePermissions = userPermissions?.[moduleName];
    if (!Array.isArray(modulePermissions) || modulePermissions.length === 0) return false;

    const permissions = Array.isArray(permission) ? permission : [permission];
    return permissions.some(p => modulePermissions.includes(p));
  };

  return { hasPermission };
};
